/**
 * @deprecated Use {@link TransportType} instead.
 */
export enum LegacyTransportType {
    DELIVERY = 'delivery',
    PICKUP = 'pickup',
    TRANSFER = 'transfer'
}
